import React, {PureComponent as Component} from 'react'; 
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import {MCbrowser} from "../../../Context/browserContext";


class  Chat   extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }


    componentDidMount(){

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevState.loaded) {
            if (this.context.page.pageBreadcrumbs.current != null) {
                this.context.page.pageBreadcrumbs.current.setCurrent("chat");
                this.context.page.pageBreadcrumbs.current.show();
            }
        }
    }

   

    render() {

        return (
            <div className="row">
                <main className="col col-xl-9 order-xl-2 col-lg-12 order-lg-1 col-md-12 col-sm-12 col-12">
                    <div className="box shadow-sm rounded bg-white mb-3 osahan-chat">
                        <h5 className="pl-3 pt-3 pr-3 border-bottom mb-0 pb-3">
                            پیام رسان
                        </h5>
                        <div className="row m-0">
                            <div className="border-right col-lg-5 col-xl-4 px-0">
                                <div className="osahan-chat-left">
                                    <div className="position-relative icon-form-control p-3 border-bottom">
                                        <i className="feather-search position-absolute"/>
                                        <input placeholder="جستجو پیام ها" type="text" className="form-control" />
                                    </div>
                                    <div className="osahan-chat-list">
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center bg-light border-left border-primary  border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا جعفرپور
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check"/>
                                                    مدیریت مجموعه بهسازان - مدیر تولید
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt=""/>
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-3.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    میلاد محمدی
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    خبرنگار
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small"> 00:21 </div>
                                              </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-5.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                        <div
                                            className="p-3 d-flex align-items-center border-bottom osahan-post-header overflow-hidden">
                                            <div className="dropdown-list-image mr-3">
                                                <img className="rounded-circle" src="/images/testimonial-4.jpg" alt="" />
                                            </div>
                                            <div className="font-weight-bold mr-1 overflow-hidden">
                                                <div className="text-truncate">
                                                    رضا افروخته
                                                </div>
                                                <div className="small text-truncate overflow-hidden text-black-50">
                                                    <i className="feather-check text-primary"/>
                                                    تحلیل گر و طراح رابط کاربری
                                                </div>
                                            </div>
                                            <span className="ml-auto mb-auto">
                                                <div className="text-right text-muted pt-1 small">00:21 </div>
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-xl-8 px-0">
                                <div className="p-3 d-flex align-items-center  border-bottom osahan-post-header">
                                    <div className="font-weight-bold mr-1 overflow-hidden">
                                        <div className="text-truncate">
                                            رضا جعفرپور
                                        </div>
                                        <div className="small text-truncate overflow-hidden text-black-50">
                                            مدیریت مجموعه بهسازان - مدیر تولید
                                        </div>
                                    </div>
                                    <span className="ml-auto">
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-light btn-sm rounded"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="feather-more-vertical"/>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-1">
                                                <button className="dropdown-item" type="button"><i
                                                    className="feather-trash"/>
                                                حذف
                                                </button>
                                                <button className="dropdown-item" type="button"><i
                                                    className="feather-x-circle"/>
                                                غیرفعال
                                                </button>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div className="osahan-chat-box p-3 border-top border-bottom bg-light">
                                    <div className="text-center my-3">
                                          <span className="px-3 py-2 small bg-white shadow-sm  rounded">
                                              2 آبان 1400
                                          </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto">
                                            <img className="rounded-circle" src="/images/testimonial-1.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                میلاد محمدیان
                                            </div>
                                            <p>
                                                سلام مهندس
                                            </p>
                                            <p>
                                                حالتون چطوره .؟ خوب هستید...
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                         <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="text-center my-3">
                                          <span className="px-3 py-2 small bg-white shadow-sm rounded">
                                              3 آبان 1400
                                          </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto"><img
                                            className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto"><img
                                            className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto">
                                            <img className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="text-center my-3">
                                          <span className="px-3 py-2 small bg-white shadow-sm rounded">
                                              8 آبان 1400
                                          </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto"><img
                                            className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto"><img
                                            className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center osahan-post-header">
                                        <div className="dropdown-list-image mr-3 mb-auto"><img
                                            className="rounded-circle" src="/images/testimonial-2.jpg" alt="" /></div>
                                        <div className="mr-1">
                                            <div className="text-truncate h6 mb-3">
                                                رضا جهان تیغ
                                            </div>
                                            <p>
                                                زمان ثبت نام فرا رسید .
                                                لطفا در آزمون شرکت کنید ... ممنون
                                            </p>
                                        </div>
                                        <span className="ml-auto mb-auto">
                                        <div className="text-right text-muted pt-1 small">00:21 </div>
                                        </span>
                                    </div>
                                </div>
                                <div className="w-100 border-top border-bottom">
                                    <textarea placeholder="متن پیام ... "
                                              className="form-control border-0 p-3 shadow-none" rows="2"></textarea>
                                </div>
                                <div className="p-3 d-flex align-items-center">
                                    <div className="overflow-hidden">
                                        <button type="button" className="btn btn-light btn-sm rounded">
                                            <i className="feather-image"/>
                                        </button>
                                        <button type="button" className="btn btn-light btn-sm rounded">
                                            <i className="feather-paperclip"/>
                                        </button>
                                        <button type="button" className="btn btn-light btn-sm rounded">
                                            <i className="feather-camera"/>
                                        </button>
                                    </div>
                                    <span className="ml-auto">
                                        <button type="button" className="btn btn-primary btn-sm rounded btn-1">
                                            ارسال
                                            پیام
                                            <i className="feather-send ml-2 line-h-1_5"/>

                                        </button>
                                      </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <aside className="col col-xl-3 order-xl-2 col-lg-12 order-lg-2 col-12">
                    <ShowProfile  />
                </aside>
            </div>
        );
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Chat.contextType = MCbrowser;

export default Chat;
